import React from 'react';
import { classes as newColorsBrandingClasses, st, } from './newColorsBranding.st.css.js';
import { classes as madeforClasses } from './madefor.st.css.js';
import { classes } from './WixDesignSystemProvider.st.css.js';
import { WixDesignSystemContext } from './context';
import { WixStyleReactEnvironmentContext } from '../WixStyleReactEnvironmentProvider/context';
import WixStyleReactEnvironmentProvider from '../WixStyleReactEnvironmentProvider';
const WixDesignSystemProvider = ({ dataHook, className, as = 'span', mobile = false, children, theme, features = {}, locale, pageHeaderId, ...rest }) => {
    const compactMode = features?.compactMode || false;
    const newColorsBranding = true;
    const newBrandingClass = newColorsBrandingClasses.root;
    const environmentContext = React.useContext(WixStyleReactEnvironmentContext);
    return (React.createElement(WixDesignSystemContext.Provider, { value: { newBrandingClass, newColorsBranding, mobile, compactMode } },
        React.createElement(WixStyleReactEnvironmentProvider, { locale: locale ?? environmentContext?.locale, pageHeaderId: pageHeaderId ?? environmentContext?.pageHeaderId }, React.createElement(as, {
            ...rest,
            'data-hook': dataHook,
            'data-newcolorsbranding': newColorsBranding,
            className: st(className, newBrandingClass, madeforClasses.madefor, theme?.className, mobile && classes.mobile),
        }, children))));
};
export default WixDesignSystemProvider;
//# sourceMappingURL=WixDesignSystemProvider.js.map